import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  userPostsWrapper: {},
  newPostWrapper: {
    ...theme.mixins.appContainer,
    width: '100%',
    marginBottom: theme.spacing(1),
  },
  uploadedFilesWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    marginBottom: theme.spacing(1),
  },
  newPostData: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  '& > div + div': {
    marginTop: 16,
  },

  '& > div:first-of-type': {
    marginTop: 0,
  },
  userPostsContainer: {},
}));
